import { useState } from "react";
import { Download, Link2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

/** "Download PDF" — the browser's own Save-as-PDF keeps the contents list and
 *  every link clickable, so we steer the reader to the right destination
 *  before opening the print dialog. */
export function KbPdfDialog() {
  const [open, setOpen] = useState(false);
  const go = () => {
    setOpen(false);
    setTimeout(() => window.print(), 250);
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm" data-testid="kb-download-pdf-button" title="Save this article as a PDF">
          <Download className="h-4 w-4" /> Download PDF
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-md" data-testid="kb-pdf-dialog">
        <DialogHeader>
          <DialogTitle>Save as PDF</DialogTitle>
          <DialogDescription>
            Your browser builds the PDF. In the print dialog that opens next, set the destination to
            <span className="font-semibold text-slate-700 dark:text-slate-200"> Save as PDF</span> (Chrome or Edge).
          </DialogDescription>
        </DialogHeader>
        <ul className="space-y-2 text-sm text-slate-600 dark:text-slate-300">
          <li className="flex gap-2">
            <Link2 className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
            <span>The contents list, section links and web links stay clickable in the saved file.</span>
          </li>
          <li className="flex gap-2">
            <Download className="mt-0.5 h-4 w-4 shrink-0 text-amber-600" />
            <span>Avoid <span className="font-medium">Microsoft Print to PDF</span> and other printer-style PDF options — they turn links into plain text.</span>
          </li>
        </ul>
        <DialogFooter>
          <Button variant="ghost" size="sm" onClick={() => setOpen(false)} data-testid="kb-pdf-cancel">Cancel</Button>
          <Button size="sm" onClick={go} data-testid="kb-pdf-continue">Open print dialog</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
